import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';
import Firebase, { FirebaseContext } from './components/Firebase';
import { ToastProvider } from './contexts/ToastContext';
import { installGlobalChunkReloadHandler } from './utils/chunkReload';
import 'bootstrap/dist/css/bootstrap.min.css';

// styles
import "./assets/css/nucleo-icons.css";
import "./styles/index.scss";

/*
console.log("ENV variables:", {
    REACT_APP_API_KEY: process.env.REACT_APP_API_KEY,
    REACT_APP_PROJECT_ID: process.env.REACT_APP_PROJECT_ID,
    // other env vars
  });
*/


// Recover automatically when a stale tab requests a chunk that a new deploy
// has replaced (see utils/chunkReload).
installGlobalChunkReloadHandler();

ReactDOM.render(
    <FirebaseContext.Provider value={new Firebase()}>
        <ToastProvider>
            <App />
        </ToastProvider>
    </FirebaseContext.Provider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
